<template>
  <div class="new-main centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>我的课程</span>
    </div>
<!--    <div class="d-flex d-align-center search-wrap">-->
<!--      <el-input v-model="name" placeholder="请输入分类"></el-input>-->
<!--      <el-button>搜索</el-button>-->
<!--    </div>-->
    <div class="new-w9 centerWidth" v-for="(category, categoryIndex) in allList" :key="categoryIndex">
      <!--      <div class="new-tit-3 d-flex d-align-center">-->
      <!--        <div class="line"></div>-->
      <!--        <div class="tit cur">{{ item.type_name }}</div>-->
      <!--      </div>-->
      <div class="new-tit2 new-tit d-flex d-just-between d-align-center">
        <div class="tit cur">{{ category.name }}</div>
      </div>
      <div class="kecheng_wrap d-flex">
        <div class="d-flex" v-for="(group, groupIndex) in getGroupedCards(category.major)" :key="groupIndex">
          <div class="item" v-for="(card, cardIndex) in group" :key="cardIndex" @click="toKc(card.info.url)" :style="getColorClass(categoryIndex, groupIndex)">
            <div class="top">
              <div>{{ card.name }}</div>
              <div>{{ card.info.type == 1 ? '视频学习+题库学习' : card.info.type == 2 ? '视频学习' : '题库学习' }}</div>
              <div>{{ card.info.studytime }}学时</div>
            </div>
            <div class="bottom">智慧数字化赋能教育考培服务平台</div>
          </div>
        </div>
      </div>
    </div>

    <div style="text-align: center;padding: 20px 0 40px 0">
      <el-pagination
          :page-size="10"
          :current-page="pageNum"
          :background="true"
          layout="prev, pager, next"
          @current-change="currentChange"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  all_lists
} from "@/api/index";

export default {
  name: "courseList",
  data() {
    return {
      pageNum: 1,
      total: 0,
      allList: [],
      first_bg: '',
      second_bg: '',
      processedCategories: [],
      name:''
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    currentChange(val) {
      this.pageNum = val
      this.getList()
    },
    getList() {
      all_lists({page_no:this.pageNum,page_size:10}).then(res => {
        if (res.code == 1) {
          let allList = res.data.lists
          this.first_bg = localStorage.getItem('first_bg') ? localStorage.getItem('first_bg') : '../assets/images/kc_bg1.png'
          this.second_bg = localStorage.getItem('second_bg') ? localStorage.getItem('second_bg') : '../assets/images/kc_bg2.png'
          this.allList = allList
          this.total = res.data.count
          console.log(allList)
        }
      })
    },
    getGroupedCards(cards) {
      let result = [];
      for (let i = 0; i < cards.length; i += 4) {
        result.push(cards.slice(i, i + 4));
      }
      return result;
    },
    // 根据类型索引和组索引来决定背景颜色类名
    getColorClass(categoryIndex, groupIndex) {
      let blue = {backgroundImage: `url(${this.first_bg})`}
      let red = {backgroundImage: `url(${this.second_bg})`}
      const totalIndex = this.calculateTotalIndex(categoryIndex, groupIndex);
      return totalIndex % 2 === 0 ? blue : red;
    },
    // 计算综合索引来决定颜色
    calculateTotalIndex(categoryIndex, groupIndex) {
      let totalGroupsBefore = 0;
      for (let i = 0; i < categoryIndex; i++) {
        totalGroupsBefore += Math.ceil(this.allList[i].major.length / 4);
      }
      return totalGroupsBefore + groupIndex;
    },



    toKc(url) {
      if (url) {
        window.open(url)
      }
    },
    // getBackgroundColorStyle(globalIndex, itemIndex) {
    //   console.log(globalIndex)
    //   let blue = {backgroundImage: `url(${this.first_bg})`}
    //   let red = {backgroundImage: `url(${this.second_bg})`}
    //   const rowNumber = Math.floor(globalIndex / 4);
    //   return rowNumber % 2 === 0 ? blue : red
    //
    //   // // 根据行号决定背景颜色
    //   // return {
    //   //   backgroundColor: rowIndex % 2 === 0 ? this.blueColor : this.redColor,
    //   // };
    //   // return {
    //   //   backgroundImage: `url(${rowIndex % 2 === 0 ? this.first_bg : this.second_bg})`
    //   // };
    // }
  }
}
</script>

<style scoped lang="scss">
.new-main {
}

.new-tit-3 {
  background: #f6f5f5;
  font-size: 20px;
  font-weight: bold;
  color: #333;

  .line {
    margin-right: 15px;
    width: 5px;
    height: 48px;
    background: #2257ab;
    border-radius: 2px;
  }
}

.new-w9 {
  margin-bottom: 10px;
  margin-top: 30px;

  .kecheng_wrap {
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;

    .item {
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 180px;
      width: 282px;
      margin-right: 24px;
      position: relative;
      margin-bottom: 24px;
      box-sizing: border-box;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        color: #ffffff;
        height: 160px;

        div:nth-child(2) {
          margin: 5px 0;
        }
      }

      .bottom {
        font-size: 10px;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 20px;
        line-height: 20px;
        color: #fff;
        text-align: center;
      }
    }
  }

  .kecheng_wrap_1 {
    .item {
      background-image: url("../assets/images/kc_bg1.png");
    }
  }

  .kecheng_wrap_2 {
    .item {
      background-image: url("../assets/images/kc_bg2.png");
    }
  }
}
.search-wrap{
  margin-top: 30px;
}
</style>
